// components/data/KpiCard.tsx

import React from "react";

interface KpiCardProps {
  title: string;
  value: number | string;
  subtitle?: string;
}

export const KpiCard: React.FC<KpiCardProps> = ({
  title,
  value,
  subtitle,
}) => {
  return (
    <div className="bg-white rounded-xl shadow-md border border-secondary-200 p-5 text-center">
      <h3 className="text-xs font-medium text-secondary-600 mb-1.5 uppercase tracking-wide">
        {title}
      </h3>

      <div className="text-3xl font-bold text-primary-600">
        {typeof value === "number"
          ? value.toLocaleString(undefined, {
              maximumFractionDigits: 2,
            })
          : value}
      </div>

      {subtitle && (
        <p className="text-xs text-secondary-500 mt-2">{subtitle}</p>
      )}
    </div>
  );
};
